import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@3plearning/react-components';
import BackIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_back.svg';
import styleable from 'react-styleable';
import css from './table-header.scss';

/**
 * Displays table title and back button
 * Back button goes to previous state in history, ReportFilters component handles updating the
 * active filters
 */
class TableHeader extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        showButton: PropTypes.bool,
        translate: PropTypes.bool
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props) {
        super(props);
        const i18n = window.i18n;
        const { title, translate } = props;
        if (translate && i18n) {
            this.title = i18n._(title);
        } else {
            this.title = title;
        }
    }

    render() {
        const { history } = this.context.router;
        const { showButton } = this.props;

        return (
            <div className={css.component}>
                {showButton && (
                    <Button
                        primary
                        icon={BackIcon}
                        onClick={history.goBack}
                        className={css['back-button']}
                    />
                )}
                <h3>{this.title}</h3>
            </div>
        );
    }
}

TableHeader.defaultProps = {
    showButton: true
};

export default styleable(css)(TableHeader);



// WEBPACK FOOTER //
// ./components/table-header/table-header.js